_ = require 'underscore'
View = require 'views/internal/view'
sidebarAction = require 'views/templates/card_detail_sidebar_button'

module.exports = class CustomFieldCardButtonView extends View
  tagName: 'span'

  renderOnce: ->
    @$el.html(sidebarAction('js-edit-fields', 'custom-field', 'custom-fields'))
    @



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-card-button-view.coffee